import { useDispatch, useSelector } from "react-redux";
import { setMainLoading, setPageTitle } from "../../Store/reducers/Common";
import { useEffect, useMemo, useState } from "react";
import EventsSubMenus from "./EventsSubMenus";
import { Link, useNavigate } from "react-router-dom";
import { PostAxios, responseCatchFunc } from "../../Services/RequestService";
import Pagination from "../../Services/Pagination";
import moment from "moment";
import useConfirm from "../../Services/Confirmation";
import { ConvertErrorArrayToString } from "../../Services/Common";
import { setToastData } from "../../Store/reducers/Toast";
import { EVENT_TYPE_FILTER_OPTIONS, EVENT_TYPE_LABEL_MAP, EVENT_MODE_LABEL_MAP } from "./constants";
import { canShowDivisionRegisterButton } from "./divisionRegistrationEventUtils";

const EventsList = () => {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const { userData, accessToken } = useSelector((state) => state.user);
    const [showFilter, setShowFilter] = useState(true);
    const [currentPage, setCurrentPage] = useState(1);
    const customConfirm = useConfirm();
    const [paginationData, setPaginationData] = useState({ total: 0, per_page: 20 });
    const [filter, setFilter] = useState({
        org_id: userData.role_slug === "super_admin" ? 0 : userData.org_id,
        div_id: userData.role_slug === "super_admin" || userData.role_slug === "org_admin" ? 0 : userData.user_div,
        event_type: "all",
    });
    const [orgList, setOrgList] = useState([]);
    const [divList, setDivList] = useState([]);
    const [eventList, setEventList] = useState([]);
    const filterHandler = (key, value) => {
        setFilter({ ...filter, [key]: value });
    }
    useEffect(() => {
        dispatch(setPageTitle(`Events`));
        dispatch(setMainLoading(true));
        let promiseArray = [];
        if (userData.role_slug === "super_admin") {
            promiseArray.push(PostAxios(`masters/organization`, { page: 1, perPage: 1000 }, accessToken));
        }
        if (userData.role_slug === "super_admin" || userData.role_slug === "org_admin") {
            promiseArray.push(PostAxios(`masters/division-list`, { org_id: userData.role_slug === "super_admin" ? 0 : userData.org_id, page: 1, perPage: 1000 }, accessToken));
        }
        if (promiseArray.length > 0) {
            Promise.all(promiseArray)
                .then((response) => {
                    if (response[0].config.url === "masters/organization") {
                        if (response[0].data.status === "1") {
                            setOrgList(response[0].data.data);
                        }
                    }
                    else {
                        if (response[0].data.status === "1") {
                            setDivList(response[0].data.data);
                        }
                    }
                    if (response?.[1]?.config?.url === "masters/division-list") {
                        if (response[1].data.status === "1") {
                            setDivList(response[1].data.data);
                        }
                    }
                    runFilter();
                })
                .catch(err => {
                    responseCatchFunc(dispatch, err);
                })
        }
        else {
            runFilter();
        }
    }, [accessToken, userData]);
    const filteredDivList = useMemo(() => {
        let tempL = [];
        let orgId = parseInt(filter.org_id);
        for (let div of divList) {
            if (parseInt(div.org_id) === orgId || orgId === 0) {
                tempL.push(div);
            }
        }
        return tempL;
    }, [filter.org_id, divList])
    const runFilter = (pageNo = 0) => {
        dispatch(setMainLoading(true));
        setEventList([]);
        let postData = {
            ...filter
        }
        if (pageNo > 0) {
            postData.page = pageNo
            postData.perPage = paginationData.per_page
        }
        PostAxios(`event/event-list`, postData, accessToken)
            .then(({ data }) => {
                if (data.status === "1") {
                    if (data?.totalRecords) {
                        setPaginationData({ total: data?.totalRecords, per_page: data?.perPage });
                    }
                    setEventList(data.data);
                }
            })
            .catch((err) => {
                responseCatchFunc(dispatch, err)
            })
            .finally(() => {
                dispatch(setMainLoading(false));
            })
    }
    const deleteEvent = async (event_id) => {
        let userChoice = await customConfirm({
            description: `Do you want to delete this event?`,
        });
        if (!userChoice) {
            return;
        }
        dispatch(setMainLoading(true));
        PostAxios(`event/delete-event`, { event_id }, accessToken)
            .then(({ data }) => {
                if (data.status === "1") {
                    dispatch(setToastData({ message: `${data.message} `, isHtml: true, type: 'success', showCloseBtn: true }))
                    runFilter();
                }
                else {
                    dispatch(setToastData({ message: (data.errors) ? ConvertErrorArrayToString(data.errors) : data.message, isHtml: true, type: 'error', showCloseBtn: true }))
                }
            })
            .catch(err => {
                responseCatchFunc(dispatch, err);
            })
            .finally(() => {
                dispatch(setMainLoading(false));
            })
    }
    return (
        <>
            <EventsSubMenus />
            <div className="main-form-sec">
                <div className="top-right-btn p-0">
                    {
                        (userData.role_slug === "super_admin" || userData.role_slug === "org_admin" || userData.role_slug === "captain" || userData.role_slug === "div_admin" || userData.caps_list.includes('add_event')) &&

                        <Link
                            to={"/events/add"}
                            className="btn-blue btn br-0"
                        >
                            Add New Event
                        </Link>
                    }
                    {
                        (userData.role_slug === "super_admin" || userData.role_slug === "org_admin") &&
                        <Link
                            to={"/events/add-division-registration"}
                            className="btn-blue btn br-0 ms-2"
                        >
                            Add Division Registration Event
                        </Link>
                    }
                </div>
                <div className="top-reports-filter">
                    <div className={`right-filter-sec`}>
                        <button className="filter-toggle" onClick={() => {
                            setShowFilter(!showFilter);
                        }}>
                            <i className="fa-solid fa-filter"></i>
                        </button>
                        <div className={`p-0 filter-search form-field-group report-filter  ${(showFilter) ? '' : 'filter-active'}`}>
                            {
                                userData.role_slug === "super_admin" &&
                                <div className="report-filter-field">
                                    <label className="select-input-outer">Organization</label>
                                    <div className="static-items-outer">
                                        <select
                                            id="org_id"
                                            name="org_id"
                                            className="select-input"
                                            value={filter.org_id}
                                            onChange={(e) => setFilter({ ...filter, "org_id": e.target.value, div_id: 0 })}
                                        >
                                            <option value='0'>All</option>
                                            {
                                                orgList.length > 0 && orgList.map((item, index) => <option key={`org-${index}`} value={item.ID}>{item.short_name}</option>)
                                            }
                                        </select>
                                    </div>
                                </div>
                            }
                            {
                                (userData.role_slug === "super_admin" || userData.role_slug === "org_admin") &&
                                <div className="report-filter-field">
                                    <label className="select-input-outer">Division</label>
                                    <div className="static-items-outer">
                                        <select
                                            id="div_id"
                                            name="div_id"
                                            className="select-input"
                                            value={filter.div_id}
                                            onChange={(e) => filterHandler("div_id", e.target.value)}
                                        >
                                            <option value='0'>All</option>
                                            {
                                                filteredDivList.length > 0 && filteredDivList.map((item, index) => <option key={`div-list-${index}`} value={item.ID}>{item.division_name} {`(${item.division_number})`}</option>)
                                            }
                                        </select>
                                    </div>
                                </div>
                            }
                            {
                                (userData.role_slug === "super_admin" || userData.role_slug === "org_admin") &&
                                <div className="report-filter-field">
                                    <label className="select-input-outer">Event Type</label>
                                    <div className="static-items-outer">
                                        <select
                                            id="event_type"
                                            name="event_type"
                                            className="select-input"
                                            value={filter.event_type}
                                            onChange={(e) => filterHandler("event_type", e.target.value)}
                                        >
                                            {
                                                EVENT_TYPE_FILTER_OPTIONS.map((item) => (
                                                    <option key={`event-type-${item.value}`} value={item.value}>{item.label}</option>
                                                ))
                                            }
                                        </select>
                                    </div>
                                </div>
                            }
                            {
                                (userData.role_slug === "super_admin" || userData.role_slug === "org_admin") &&
                                <button type="button" className="btn btn-blue ms-2" onClick={() => { setCurrentPage(1); runFilter(1); }}>Submit</button>
                            }
                        </div>
                    </div>
                </div>
                <div className="table-wrapper">
                    <table className="table">
                        <thead>
                            <tr>
                                <th>S.No.</th>
                                <th>Title</th>
                                <th>Event Type</th>
                                <th>Location</th>
                                <th style={{ minWidth: 130 }}>Date & Time</th>
                                <th style={{ minWidth: 110 }}>Mohalla</th>
                                <th style={{ minWidth: 90 }}>Action</th>
                            </tr>
                        </thead>
                        <tbody>
                            {
                                eventList.length > 0 && eventList.map((item, index) => {
                                    let divName = '';
                                    if (parseInt(item.event_user_div) === 0 || item.event_user_div === "all") {
                                        divName = 'All';
                                    }
                                    else if (item.div_name_list !== null && item.div_name_list.trim() !== "") {
                                        let splitDNl = item.div_name_list.split(';');
                                        for (let i of splitDNl) {
                                            let splitDn = i.split('|');
                                            if (parseInt(splitDn[0]) === parseInt(userData.user_div)) {
                                                divName = splitDn[1];
                                                break;
                                            }
                                            else if (userData.role_slug === "super_admin" || userData.role_slug === "org_admin") {
                                                if (divName !== "") {
                                                    divName += ', ';
                                                }
                                                divName += splitDn[1];
                                            }
                                        }
                                    }
                                    else if (parseInt(item.event_user_div) === parseInt(userData.user_div)) {
                                        divName = item.division_name;
                                    }
                                    return <tr key={`event-item-${index}`}>
                                        <td>{(currentPage - 1) * paginationData.per_page + index + 1}</td>
                                        <td>
                                            {item.event_title}
                                            {item.event_mode === "division_registration" &&
                                                (userData.role_slug === "super_admin" || userData.role_slug === "org_admin") && (
                                                <span className="badge bg-info ms-1">{EVENT_MODE_LABEL_MAP.division_registration}</span>
                                            )}
                                        </td>
                                        <td>{EVENT_TYPE_LABEL_MAP[item.event_type] || "Local"}</td>
                                        <td>{item.event_location}</td>
                                        <td>
                                            {moment(`${item.event_start_date} ${item?.event_start_time}`).format('DD MMM YY h:mm a')}
                                            &nbsp; - &nbsp;
                                            {moment(`${item.event_end_date} ${item?.event_end_time}`).format('DD MMM YY h:mm a')}
                                        </td>
                                        <td>{divName}</td>
                                        <td>
                                            {
                                                item.event_mode === "division_registration"
                                                    ? (userData.role_slug === "super_admin" || userData.role_slug === "org_admin") && (
                                                        <button type="button" className="btn-blue btn btn-sm" title="Edit Event" onClick={() => {
                                                            navigate('edit-division-registration', { state: { event_id: item.id } });
                                                        }}>
                                                            <i className="fa-solid fa-pencil"></i>
                                                        </button>
                                                    )
                                                    : (
                                                        (userData.role_slug === "super_admin" || userData.role_slug === "org_admin" ||
                                                            (
                                                                (parseInt(item.event_admin) === parseInt(userData.id) || parseInt(item.event_incharge) === parseInt(userData.id))
                                                                &&
                                                                moment(`${item.event_start_date} ${item?.event_start_time}`) > moment()
                                                            )
                                                        ) &&
                                                        <button type="button" className="btn-blue btn btn-sm" title="Edit Event" onClick={() => {
                                                            navigate('edit', { state: { event_id: item.id } });
                                                        }}>
                                                            <i className="fa-solid fa-pencil"></i>
                                                        </button>
                                                    )
                                            }
                                            <button type="button" className="btn-blue btn btn-sm ms-2" title="View Event" onClick={() => {
                                                navigate('view', { state: { event_id: item.id } });
                                            }}>
                                                <i className="fa-solid fa-eye"></i>
                                            </button>
                                            {
                                                canShowDivisionRegisterButton(item, userData.role_slug) &&
                                                <button type="button" className="btn-blue btn btn-sm ms-2" title="Register Members" onClick={() => {
                                                    navigate('view', { state: { event_id: item.id, scrollToRegister: true } });
                                                }}>
                                                    <i className="fa-solid fa-user-plus"></i> Register
                                                </button>
                                            }
                                            {
                                                (userData.role_slug === "super_admin" || userData.role_slug === "org_admin" ||
                                                    parseInt(item.event_admin) === parseInt(userData.id) || parseInt(item.event_incharge) === parseInt(userData.id)
                                                    // userData.role_slug === "captain" || userData.role_slug === "div_admin"

                                                )
                                                &&
                                                <button type="button" className="btn-blue btn btn-sm ms-2" title="Duty Chart" onClick={() => {
                                                    navigate('duty-chart', { state: { event_id: item.id } });
                                                }}>
                                                    Duty Chart
                                                </button>
                                            }
                                            {
                                                (userData.role_slug === "super_admin" || userData.role_slug === "org_admin" ||
                                                    parseInt(item.event_admin) === parseInt(userData.id) || parseInt(item.event_incharge) === parseInt(userData.id)
                                                    // userData.role_slug === "captain" || userData.role_slug === "div_admin"

                                                )
                                                &&
                                                moment(`${item.event_start_date} ${item?.event_start_time}`) > moment()
                                                &&
                                                <button type="button" className="btn-blue btn btn-sm btn-status rejected ms-2" title="Delete Event" onClick={() => {
                                                    deleteEvent(item.id);
                                                }}>
                                                    <i className="fa-solid fa-trash"></i>
                                                </button>
                                            }
                                        </td>
                                    </tr>
                                })
                            }
                        </tbody>
                    </table>
                </div>
                <Pagination
                    currentPage={currentPage}
                    totalCount={paginationData.total}
                    pageSize={paginationData.per_page}
                    onPageChange={page => {
                        setCurrentPage(page);
                        runFilter(page);
                    }}
                />
            </div>
        </>
    )
}

export default EventsList;